// Per-role session inactivity windows (spec: 2026-07-03-driver-session-ttl-design.md).
// 前後端共用：後端 activityMonitor 據此強制執行，前端 useAuth 閒置計時器據此排程，
// 兩側必須使用同一份常數，避免前端提早登出抵銷後端的長效 session 設計。

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;

export const DEFAULT_SESSION_TIMEOUT_MS = 10 * MINUTE_MS;

export const SESSION_TIMEOUTS: Record<string, number> = {
  admin: 10 * MINUTE_MS,
  staff: 10 * MINUTE_MS,
  // Drivers keep a long-lived mobile session; daily use rolls it forward.
  driver: 12 * HOUR_MS,
};

export const MAX_SESSION_TIMEOUT_MS = Math.max(
  ...Object.values(SESSION_TIMEOUTS),
  DEFAULT_SESSION_TIMEOUT_MS,
);

export function getSessionTimeoutMs(role?: string): number {
  if (!role) {
    return DEFAULT_SESSION_TIMEOUT_MS;
  }
  return SESSION_TIMEOUTS[role] ?? DEFAULT_SESSION_TIMEOUT_MS;
}
